import { useRef } from "react";

import { devWarn } from "./devWarning";

/**
 * Fires `devWarn(message)` the first render where `condition` is true and never again
 * for that instance. Keeps render-loop dev warnings (accessible-name checks, Field/id
 * conflicts) from spamming the console.
 */
export function useDevWarnOnce(condition: boolean, message: string): void {
  const warnedRef = useRef(false);
  if (condition && !warnedRef.current) {
    warnedRef.current = true;
    devWarn(message);
  }
}
